// `_each` : a collection's function
// ---------------------------------

// The cornerstone, an `each` implementation, aka `forEach`.
export {default} from './forEach';